import Button from "@mui/material/Button";
import React, { useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "../../AppBar";
import SubHeader from "../../SubHeader";
import useComponentSize from "@rehooks/component-size";

import useTemplateInstance from "../../../hooks/useTemplateInstance";
import { getPartRefIds } from "../../../../../Providers/TemplateInstanceProvider";
import { Trans } from "react-i18next";
import ActionsContainer from "./ActionsContainer";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  templateContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
  },
  pageList: {
    padding: 0,
    margin: 0,
    display: "grid",
    [theme.breakpoints.up("xs")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    [theme.breakpoints.up("lg")]: {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    gridGap: theme.spacing(1),
    listStyle: "none",
    "&> li": {
      paddingTop: "100%",
      position: "relative",
    },
  },
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const [state] = useTemplateInstance();

  return (
    <div className={classes.mainContainer}>
      <SubHeader onClick={() => changeMenu("main")}>Forhåndsvisning</SubHeader>

      <ul class={classes.pageList}>
        {getPartRefIds(state.template).map((partRefId, index) => {
          return (
            <li key={partRefId}>
              <TemplateContainer
                partRefId={partRefId}
                templateInstance={state}
              />
            </li>
          );
        })}
      </ul>

      <ActionsContainer>
        <Button color="primary" onClick={() => changeMenu("main")}>
          <Trans>Cancel</Trans>
        </Button>
        <Button color="primary" onClick={() => changeMenu("main")}>
          <Trans>Done</Trans>
        </Button>
      </ActionsContainer>
    </div>
  );
};

const TemplateContainer = ({ templateInstance, partRefId }) => {
  // Use a ref to attach to the element whose visibility you want to keep track of.
  const ref = useRef();
  // `current` points to the mounted img element.
  const size = useComponentSize(ref);

  console.log("Template instance", templateInstance);

  const classes = useStyles();
  return (
    <div ref={ref} className={classes.templateContainer}>
      <DrawTemplate
        containerSize={size}
        templateInstance={templateInstance}
        partRefId={partRefId}
      />
    </div>
  );
};
